const FormField = ({
  label,
  name,
  type,
  value,
  onChange,
  error,
  isSelect,
  options,
  onBlur,
  disabled,
  readOnly,
  className,
  step,
  required,
  rows,
  placeholder,
}) => {
  return (
    <div className="relative mb-4">
      {label && (
        <label className="absolute top-[-12px] left-3 bg-white px-1 text-brand-charcoal">
          {label}
        </label>
      )}
      {isSelect ? (
        <select
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`border border-brand-charcoal/20 p-3 rounded-lg w-full bg-white text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink transition duration-200 ${
            className || ""
          }`}
        >
          <option value="" disabled>
            Select {label?.toLowerCase() || "an option"}
          </option>
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : type === "textarea" ? (
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          readOnly={readOnly}
          required={required}
          rows={rows || 4}
          placeholder={placeholder}
          className={`border border-brand-charcoal/20 p-3 rounded-lg w-full bg-white text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink transition duration-200 resize-none ${
            className || ""
          }`}
        />
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          readOnly={readOnly}
          step={step}
          required={required}
          placeholder={placeholder}
          className={`border border-brand-charcoal/20 p-3 rounded-lg w-full bg-white text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink transition duration-200 ${
            className || ""
          }`}
        />
      )}
      {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default FormField;
